import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import cacheService from '../services/cacheService';

const WeatherContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

const CurrentWeather = styled.div`
  display: flex;
  align-items: center;
`;

const Temperature = styled.span`
  color: white;
`;

const Weather = () => {
  const [weather, setWeather] = useState([]);
  const [error, setError] = useState(null);
  const [retryTimeout, setRetryTimeout] = useState(null);

  const fetchWeather = async () => {
    try {
      const data = await cacheService.getWeather();
      if (data && data.length > 0) {
        setWeather(data);
        setError(null);
        // Clear any existing retry timeout
        if (retryTimeout) {
          clearTimeout(retryTimeout);
          setRetryTimeout(null);
        }
      }
    } catch (error) {
      console.error('Error fetching weather:', error);
      setError(error);
      // If we have no weather data, retry in 30 minutes
      if (weather.length === 0 && !retryTimeout) {
        const timeout = setTimeout(() => fetchWeather(), 30 * 60 * 1000);
        setRetryTimeout(timeout);
      }
    }
  };

  useEffect(() => {
    fetchWeather();
    return () => {
      if (retryTimeout) {
        clearTimeout(retryTimeout);
      }
    };
  }, []);

  if (error && weather.length === 0) return null;
  if (weather.length === 0) return null;

  const currentWeather = weather[0];

  return (
    <WeatherContainer>
      <CurrentWeather>
        <Temperature>{Math.round(currentWeather.temperature)}°C</Temperature>
      </CurrentWeather>
      {}
    </WeatherContainer>
  );
};

export default Weather;
